module.exports = __webpack_public_path__ + "static/media/login.b84e11f2.png";